module.exports = __webpack_public_path__ + "static/img/1.332cca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Responsabilidad-civil-danos-terceros/1.png
// module id = 3/d/
// module chunks = 0